<template>
  <nav
    :class="[$style.nav, { [$style.navSolid]: solid }]"
    data-l1="40"
    role="navigation"
    aria-label="站点主导航"
  >
    <div :class="$style.navBody">
      <!-- ===== 左侧：Logo + 分类按钮组 ===== -->
      <div :class="$style.leftGroup">
        <a
          :class="$style.logo"
          :href="homeHref"
          data-eid="qd_A43"
          :title="siteName"
          :aria-label="siteName"
        >
          <!-- <svg
            :class="$style.logoIcon"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            aria-hidden="true"
          >
            <path
              fill="#E5353E"
              d="M12.49 0.4l2.15 0.59c.53.15.91.62.94 1.17l.15 2.54h10.64c.15 0 .26.14.23.28l-.33 1.76a1.13 1.13 0 01-1.26 1.04H13.18c-1.75 2.78-3.36 4.91-4.84 6.42 2.24-.11 4.44-.21 6.63-.37 1.31-1.41 2.59-2.86 3.82-4.34a1.25 1.25 0 011.55-.33l1.75.89c.14.07.17.25.07.36-5.26 5.95-9.72 10.32-13.34 13.07 4.11-.36 8.12-.84 12.09-1.42-.43-.84-.88-1.7-1.33-2.56a1.42 1.42 0 01.66-1.91l.88-.54c.11-.07.26-.03.33.08 1.71 2.95 3.1 5.59 4.15 7.9a1.42 1.42 0 01-.63 2.26l-1.24.87a.22.22 0 01-.32-.05c-.36-.85-.73-1.71-1.11-2.58-4.9.86-11.09 1.5-18.5 1.92a.22.22 0 01-.24-.17l-.73-2.65a.22.22 0 01.16-.29c.93-.28 1.95-.82 3.02-1.57 2.1-1.67 4.09-3.44 6-5.26-2.62.16-5.4.3-8.33.43a.22.22 0 01-.24-.17L2.85 14.5a.22.22 0 01.2-.3c.48-.06.84-.16 1.09-.25.67-.38 1.49-1.1 2.46-2.16.94-1.02 2.01-2.35 3.22-4H2.83a1.31 1.31 0 01-1.27-1.07L1.27 4.97a.22.22 0 01.22-.27h11.05l-.35-4.06a.22.22 0 01.29-.25z"
            />
          </svg> -->
          <span :class="$style.logoText">{{ siteName }}</span>
        </a>

        <ul :class="$style.btnGroup">
          <li
            v-for="(item, idx) in navItems"
            :key="item.key"
            :class="[$style.btnItem, { [$style.btnItemActive]: item.active }]"
          >
            <a
              :class="$style.btnLink"
              :href="item.href"
              :data-eid="item.eid"
              :data-l1="idx"
            >
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>

      <!-- ===== 右侧：搜索框 ===== -->
      <div :class="$style.rightGroup">
<!--        <form-->
<!--          :class="[$style.search, { [$style.searchFocused]: isFocused }]"-->
<!--          :action="searchAction"-->
<!--          @submit.prevent="handleSubmit"-->
<!--        >-->
<!--          <div :class="$style.searchInputWrap">-->
<!--            <svg-->
<!--              :class="$style.searchIcon"-->
<!--              width="20"-->
<!--              height="20"-->
<!--              viewBox="0 0 20 20"-->
<!--              aria-hidden="true"-->
<!--            >-->
<!--              <path-->
<!--                fill="currentColor"-->
<!--                d="M9 3a6 6 0 014.47 10.01l3.76 3.76-1.06 1.06-3.76-3.76A6 6 0 119 3zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"-->
<!--              />-->
<!--            </svg>-->
<!--            <input-->
<!--              v-model="searchKeyword"-->
<!--              type="text"-->
<!--              name="kw"-->
<!--              :class="$style.searchInput"-->
<!--              :placeholder="placeholderText"-->
<!--              autocomplete="off"-->
<!--              @focus="isFocused = true"-->
<!--              @blur="isFocused = false"-->
<!--            />-->
<!--          </div>-->
<!--          <button type="submit" :class="$style.searchBtn" data-eid="qd_A62">-->
<!--            搜索-->
<!--          </button>-->
<!--        </form>-->
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue'
import { usePageContext } from '@share/ssr/usePageContext'
import { ICategory, ISubCategory } from '@share/common/matrix'
import { resolveCategoryByHost } from '@share/common/siteConfig'
import { INavOptions } from './type'

interface IPageDataLike {
  category?: ICategory
  subCategory?: ISubCategory | null
}

const props = defineProps({
  /** 当前高亮的子分类 ID，0 或不传表示高亮首页 */
  navHighLight: {
    type: Number,
    default: 0,
  },
  /** 可扩展配置项 */
  navOptions: {
    type: Object as PropType<INavOptions>,
    default: () => ({}),
  },
  /** 是否使用实体（不透明）背景样式 */
  solid: {
    type: Boolean,
    default: false,
  },
})

// ---------------------------------------------------------------------------
// 从 pageContext 获取当前站点上下文（在无 pageContext 时降级为空值）
// ---------------------------------------------------------------------------
let ctxHostname = ''
let ctxCategory: ICategory | null = null
let ctxSubCategory: ISubCategory | null = null
try {
  const pageContext = usePageContext<IPageDataLike, null>()
  ctxHostname = pageContext.hostname || ''
  const pageData = pageContext.pageProps?.pageData || ({} as IPageDataLike)
  ctxCategory = pageData.category || null
  ctxSubCategory = pageData.subCategory || null
} catch (_e) {
  // 无 pageContext 时（例如 error 页或 storybook），使用默认值
}

// 当前站点（优先 props > pageContext > host 解析兜底）
const currentCategory = computed<ICategory>(() => {
  return (
    props.navOptions.category || ctxCategory || resolveCategoryByHost(ctxHostname)
  )
})

// 当前已选中的 subCategory（props 若显式传 null 也保持 null）
const currentSubCategory = computed<ISubCategory | null>(() => {
  if ('subCategory' in props.navOptions) {
    return props.navOptions.subCategory || null
  }
  return ctxSubCategory
})

const siteName = computed(() => `${currentCategory.value.catName}网`)

const homeHref = computed(() => '/')

// ---------------------------------------------------------------------------
// 导航按钮：首页 + 当前站点子分类
// ---------------------------------------------------------------------------
interface INavItem {
  key: string
  title: string
  href: string
  active: boolean
  eid: string
}

// props.navHighLight 优先；否则按 currentSubCategory 推断
const highlightId = computed(() => {
  if (props.navHighLight) return props.navHighLight
  return currentSubCategory.value?.subCatId || 0
})

const navItems = computed<INavItem[]>(() => {
  const sub = currentCategory.value.subCat || []
  const items: INavItem[] = [
    {
      key: 'home',
      title: '首页',
      href: '/',
      active: !highlightId.value,
      eid: 'qd_A47',
    },
  ]
  sub.forEach((s, i) => {
    items.push({
      key: String(s.subCatId),
      title: s.subCatName,
      href: `/sub${s.subCatId}/`,
      active: highlightId.value === s.subCatId,
      eid: `qd_A${48 + i}`,
    })
  })
  return items
})

// ---------------------------------------------------------------------------
// 搜索框
// ---------------------------------------------------------------------------
const searchKeyword = ref('')
const isFocused = ref(false)

const placeholderText = computed(
  () =>
    props.navOptions.searchPlaceholder ||
    `搜索${currentCategory.value.catName}小说`,
)

// 搜索提交地址（跳转起点中文网 www.qidian.com 搜索页）
// URL 形态：//{env}www.qidian.com/so/{keyword}.html?_trace=qidian_websitev2&kw={keyword}
//  - 关键词同时放在路径（历史 soushu 伪静态 URL，SEO 友好）与 query.kw（显式参数）
//  - _trace=qidian_websitev2：与 url.ts 书籍详情跳转一致的矩阵站 v2 流量来源标识
const SEARCH_TRACE = 'qidian_websitev2'

const searchAction = computed(() => {
  const env = import.meta.env.VITE_ENV_TYPE
  const prefix = env === 'pro' ? '' : env
  return `//${prefix}www.qidian.com/so/`
})

const buildSearchUrl = (rawKeyword: string): string => {
  const keyword = (rawKeyword || '').trim()
  const base = searchAction.value
  // 关键词为空：仅带 trace 跳搜索首页，方便区分矩阵站来源的搜索入口点击
  if (!keyword) {
    return `${base}?_trace=${SEARCH_TRACE}`
  }
  const encoded = encodeURIComponent(keyword)
  return `${base}${encoded}.html?_trace=${SEARCH_TRACE}&kw=${encoded}`
}

const handleSubmit = () => {
  window.open(buildSearchUrl(searchKeyword.value), '_self')
}
</script>

<style lang="scss" module>
$font-base: 'PingFangSC-Regular', 'PingFang SC', 'Helvetica Neue',
  'Microsoft YaHei', sans-serif;
$primary: #e5353e;
$text-primary: #191919;
$text-secondary: #333333;
$nav-border: rgba(0, 0, 0, 0.08);
$input-bg: rgba(0, 0, 0, 0.04);
$input-placeholder: rgba(0, 0, 0, 0.3);

.nav {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid $nav-border;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  // box-sizing 隔离防止页面 reset 干扰
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

.navSolid {
  background: #ffffff;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.navBody {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  min-width: 1024px;
  height: 68px;
  margin: 0 auto;
  padding: 7px 40px;
  gap: 24px;
}

// ---- 左侧 ----
.leftGroup {
  display: flex;
  align-items: center;
  gap: 32px;
  flex: 1;
  min-width: 0;
}

.logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  flex-shrink: 0;
  text-decoration: none;
  line-height: 1;
  user-select: none;
}

.logoIcon {
  display: block;
  flex-shrink: 0;
}

.logoText {
  font-size: 20px;
  font-weight: 700;
  font-family: $font-base;
  color: $primary;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.btnGroup {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-width: 0;
}

.btnItem {
  display: flex;
  align-items: center;
  height: 54px;
}

.btnLink {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 0 16px;
  font-family: $font-base;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: $text-secondary;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
  cursor: pointer;

  &:hover {
    color: $primary;
  }
}

.btnItemActive .btnLink {
  color: $primary;
  font-weight: 600;
}

// ---- 右侧 ----
.rightGroup {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
}

.search {
  display: inline-flex;
  align-items: stretch;
  width: 280px;
  height: 44px;
  padding: 0 4px 0 0;
  background: $input-bg;
  border: 1px solid $input-bg;
  border-radius: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
}

.searchFocused {
  background: #fff;
  border-color: rgba($primary, 0.3);
}

.searchInputWrap {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
  padding: 0 12px;
}

.searchIcon {
  flex-shrink: 0;
  color: $input-placeholder;
}

.searchInput {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: $font-base;
  font-size: 14px;
  line-height: 1.5;
  color: $text-primary;

  &::placeholder {
    color: $input-placeholder;
  }
}

.searchBtn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 64px;
  margin: 4px 0;
  padding: 0 18px;
  border: none;
  border-radius: 24px;
  background: $primary;
  color: #fff;
  font-family: $font-base;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: darken($primary, 6%);
  }

  &:active {
    transform: scale(0.97);
  }
}

// ---------------------------------------------------------------------------
// 响应式
// ---------------------------------------------------------------------------
@media (max-width: 1280px) {
  .navBody {
    min-width: 990px;
    padding: 7px 24px;
    gap: 16px;
  }

  .leftGroup {
    gap: 20px;
  }

  .btnLink {
    padding: 0 12px;
  }

  .search {
    width: 220px;
  }
}

@media (max-width: 1024px) {
  .navBody {
    padding: 7px 16px;
  }

  .search {
    width: 180px;
  }

  .logoText {
    font-size: 18px;
  }
}
</style>
